<template>
  <div class="header">
    <div class="header-imgTwo">
      <div>
        <img class="header-img" src="../assets/logo.png" alt="" />
      </div>
      <div class="spanTwo">
        <span>全民数据</span>
      </div>
      <div class="footer-moon">
        <div class="moon-l">
          <img class="hea-imgTwo" src="../assets/duixiang.png" alt="" />
        </div>
        <div class="moon-l span">
          <span>无病毒</span>
        </div>
        <div class="moon-r" style="margin-left: 23%">
          <img class="hea-imgTwo" src="../assets/zuAD.png" alt="" />
        </div>
        <div class="moon-r span">
          <span>免广告骚扰</span>
        </div>
      </div>
      <div style="clear: both"></div>
      <div>
        <el-button class="footer-but" @click="jumpApp">下载APP</el-button>
      </div>
    </div>
    <div class="moon-ye" v-show="eject">
      <div class="header-imgHon">
        <img class="imgKon" src="../assets/zhixiang.png" alt="" />
      </div>
      <div class="number-mon">
        <div>
          <div class="number-color">点&nbsp;击&nbsp;右&nbsp;上&nbsp;角&nbsp;</div>
          <div>
            <img class="number-img" src="../assets/sandian.png" alt="" />
          </div>
          <div class="number-color">&nbsp;按&nbsp;钮</div>
        </div>
      </div>
      <div style="clear: both"></div>
      <div style="margin-top: 3%">
        <div class="number-color" style="margin-left: 23%">选&nbsp;择&nbsp;</div>
        <div class="number-ingTwo" style="margin-top: 2px">
          <span class="ingTwoClor">&nbsp;在浏览器中打开</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../store/config";
export default {
  data() {
    return {
      eject: false,
      resourcesUrl: "",
      message: "",
    };
  },
  created() {
    this.$axios
      .get(config + "/base/version/getNewestVersion", {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        if (res.data.code == "100200") {
          this.resourcesUrl = res.data.resultObj;
        } else {
          this.message = res.data.msg;
        }
      });
  },
  methods: {
    jumpApp() {
      let m = window.location.href.includes("platform");
      if (m) {
        window.JSHandle.loadApk(this.resourcesUrl);
      } else {
        let ua = navigator.userAgent.toLowerCase();
        console.log(ua);
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          if (this.$route.params.correct) {
            this.eject = true;
          } else {
            if (this.resourcesUrl) {
              window.location.href = this.resourcesUrl;
            } else {
              this.$message({
                message: this.message,
              });
            }
          }
        } else {
          if (this.resourcesUrl) {
            window.location.href = this.resourcesUrl;
          } else {
            this.$message({
              message: this.message,
            });
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  text-align: center;
}
.header-imgTwo {
  margin-top: 40%;
}
.header-img {
  width: 110px;
  height: 110px;
}
.spanTwo {
  margin-top: 13px;
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}
.moon-l,
.moon-r {
  float: left;
}
.footer-moon {
  padding-top: 33px !important;
  width: 155px;
  margin: 0 auto;
}
.hea-imgTwo {
  width: 11px;
  height: 12px;
}
.span {
  font-size: 10px;
  padding-top: 2px;
  padding-left: 5px;
}
.footer-but {
  width: 190px;
  height: 45px;
  background-color: rgb(3, 113, 217);
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  margin-top: 19px;
}

.moon-ye {
  position: fixed;
  top: 0;
  background: #000000;
  opacity: 0.58;
  width: 100%;
  height: 100vh;
}
.number-mon {
  width: 100%;
  margin-top: 25%;
  margin-left: 19%;
}
.number-img {
  width: 26px;
  height: 28px;
  float: left;
  margin-top: 2px;
}
.number-color {
  font-size: 22px;
  font-weight: bold;
  color: #fefefe;
  float: left;
}
.number-ingTwo {
  background-image: url("../assets/liulan.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 140px;
  height: 29px;
  line-height: 25px;
  float: left;
}
.ingTwoClor {
  font-size: 14px;
  font-weight: 500;
  margin-left: 20px;
  color: #fefefe;
}
.imgKon {
  width: 58px;
  height: 82px;
}
.header-imgHon {
  position: fixed;
  top: 1.3%;
  right: 6%;
}
</style>
>
